import type ReportTypeLocationVM from 'ab-viewModels/reportType/locationState.viewModel';
import type { ReportTypeVM } from 'ab-viewModels/reportType/reportType.viewModel';

export const fromLocationStateToVM = (reportType: ReportTypeLocationVM): ReportTypeVM => {
	return {
		name: reportType?.name,
		description: reportType?.description,
	} as ReportTypeVM;
};
